import { convertFileToBase64 } from "../../../utils/getBase64";

// eslint-disable-next-line import/prefer-default-export
export const mapTruckDataToApi = async (data, selectedTruckId, isSupplierPartner) => ({
    data: {
        type: "trucks",
        ...(selectedTruckId && { id: selectedTruckId }),
        attributes: {
            plateNumber: data.plateNumber,
            truckTypeId: data.truckType?.value,
            year: data.year,
            ...((!selectedTruckId || (selectedTruckId && data.licenseFace?.length > 0)) && {
                licenseFace: data.licenseFace?.[0]
                    ? await convertFileToBase64(data.licenseFace[0])
                    : null,
            }),
            ...((!selectedTruckId || (selectedTruckId && data.licenseBack?.length > 0)) && {
                licenseBack: data.licenseBack?.[0]
                    ? await convertFileToBase64(data.licenseBack[0])
                    : null,
            }),
            ...(data.supplierName?.value && { supplierId: data.supplierName?.value }),
            ...(isSupplierPartner && {
                supplierIds: data.suppliers.map((supplier) => supplier?.value),
            }),
            licenseExpirationDate: data.licenseExpirationDate,
            notes: data?.notes,
        },
        relationships: {
            attachment: {
                data: {
                    type: "attachment",
                    attributes: {
                        document: data.photo
                            ? await Promise.all(data.photo.map((file) => convertFileToBase64(file)))
                            : [],
                        documentType: "photo",
                        attachedItemType: "Truck",
                    },
                },
            },
        },
    },
});
